<template>
    <section
        id="feature-intro"
        class="feature-intro"
        :style="containerStyle"
    >
        <div class="container" :class="{reverse: props.reverse}">
            <!-- use css to control visible-->
            <div class="pc-image" :style="pcSizeStyle">
                <!-- use slot to avoid vite new URL cannot deal with resolve.alias. Same below. -->
                <!-- https://github.com/vitejs/vite/issues/10597 use vite plugin would be better -->
                <slot name='slot-pc-image' />
            </div>
            <div class="notice">
                <h5 class="subtitle" v-if='props.subtitle'>{{ props.subtitle }}</h5>
                <h3 class="title pc-title">{{ props.title }}</h3>
                <h3 class="m-title">{{ props.title }}</h3>
                <p class="des">{{ props.desc }}</p>
                <p
                    v-if="props.note"
                    class="note"
                    v-html="props.note">
                </p>
            </div>
            <div class='m-image'>
                <slot name='slot-mobile-image' />
            </div>
        </div>
    </section>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { IFeatureIntroductionWithImage, IFeatureIntroductionWithVideo, TFeatureIntroduction } from '../lib';

export default Vue.extend({

    props: {
        props: Object as PropType<TFeatureIntroduction>
    },

    data() {

        return {
            IO: null as null | IntersectionObserver,
        };

    },
    computed: {

        containerStyle(): string {

            const { backgroundColor } = this.props;
            return backgroundColor ? `--feature-intro-background-color: ${backgroundColor}` : '';

        },
        pcSizeStyle(): Record<string, string> {

            if ( ['video-record', 'privacy'].includes( this.props.type )) {

                const { image } = this.props as IFeatureIntroductionWithImage;
                return {
                    '--height': image.size?.height + 'px',
                    '--width': image.size?.width + 'px'
                };

            } else {

                const { video } = this.props as IFeatureIntroductionWithVideo;
                return {
                    '--height': video.size.height + 'px',
                    '--width': video.size.width + 'px'
                };

            }

        }
    },
    mounted() {

        if ( this.props.type === 'rich-notification' ) {

            let observed = document.getElementById( 'richNotification-video' ); // 被观察元素

            this.IO = new IntersectionObserver(() => {

                console.log( 'intersection' );
                ( document.getElementById( 'richNotification-video' ) as HTMLVideoElement ).currentTime = 0;
                ( document.getElementById( 'richNotification-video' ) as HTMLVideoElement ).play().catch( console.error );

            }, {});
            this.IO.observe( observed! ); // 开始观察

            console.log( 'start observe' );

        }

    },
    destroyed() {

        if ( this.props.type === 'rich-notification' ) {

            console.log( 'disconnect' );
            this.IO!.disconnect(); // 停止观察

        }

    }

});
</script>

<style lang="less" scoped>

    .feature-intro {
        padding: 50px 0;
        background-color: var(--feature-intro-background-color);
        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            @media @pc{

                &.reverse{
                    flex-direction: row-reverse;
                    .notice{
                        padding-left: 0;
                    }
                }
            }

            .notice {
                text-align: left;
                max-width: 500px;
                padding-left: 100px;
                display: flex;
                flex-direction: column;
                gap: 12px;
                line-height: 1.5;

                .des {
                    font-size: 16px;
                }
                .title {
                    font-size: 36px;
                    font-weight: 600;
                }
                .subtitle {
                    font-size: 24px;
                    font-weight: 500;
                }
                .pc-title {
                    display: block;
                }
                .m-title {
                    display: none;
                }
                .note{
                    font-size: 16px;
                    font-weight: 500;
                }
            }
            .pc-image {
                display: flex;
                justify-content: center;
                width: 600px;

                img, video {
                    height: var(--height);
                    width: var(--width);
                }
            }
            .m-image {
                display: none;
            }
        }

        @media @mobile{
            background-size: 100% auto;
            padding: 0;
            .container {
                display: block;
                .notice {
                    gap: 8px;
                    padding: 30px 20px 0;
                    max-width: 100%;
                    line-height: 1.5;
                    .subtitle{
                        font-size: 16px;
                    }
                    .pc-title {
                        display: none;
                    }
                    .m-title {
                        display: block;
                        font-weight: 500;
                        font-size: 20px;
                    }

                    .des {
                        font-size: 14px;
                    }
                    .note{
                        font-size: 14px;
                        margin-top: 0;
                    }
                }
                .m-image {
                    display: flex;
                    width: 100%;
                    margin-top: 24px;
                    img,video{
                        width: 100%;
                    }
                }
                .pc-image {
                    display: none;
                    background: none;
                }
            }

        }
    }

</style>
